import React from 'react';
import styled from 'styled-components';
import { PaystackButton } from 'react-paystack';
import ArrowRightIcon from './arrowRight';

const Wrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: hsl(348, 100%, 61%);
  color: #FFFFFF;
  position: fixed;
  bottom: ${props => props.offset || 0}px;
  width: 100%;
  height: 60px;
  box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.15);
  z-index: 11;
  padding: auto 1.25em;
  overflow: hidden;

  svg {
    margin-left: 1em;
    color: #FFFFFF;
  }

  @media screen and (min-width: 1024px) {
    display: none;
  }
`;

const PaystackButtonWrapper = styled(PaystackButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFBF00;
  color: #FFFFFF;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.15);
  z-index: 11;
  padding: auto 1.25em;
  overflow: hidden;

  svg {
    margin-left: 1em;
    color: #FFFFFF;
  }

  @media screen and (min-width: 1024px) {
    display: none;
  }
`;

// `offset` lifts the button off the bottom edge, for when something else (the
// mobile tab bar) already occupies it.
function CallToAction({ onClick, type, text, componentProps, offset }) {
  if (componentProps) {
    return (
      <PaystackButtonWrapper {...componentProps}>
        {text} <ArrowRightIcon />
      </PaystackButtonWrapper>
    )
  }

  return (
    <Wrapper type={type || 'submit'} onClick={onClick} offset={offset}>
      {text} <ArrowRightIcon />
    </Wrapper>
  )
}

export default CallToAction;